import axios from "axios";

export function fetchSettings(accountId) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/settings`
  };
  return axios(config);
}

export function fetchRecord(accountId) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/record`
  };
  return axios(config);
}

export function fetchRecordResourceCode(accountId, resource) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/record-resource?resourceCode=${resource}`
  };
  return axios(config);
}

export function fetchRecordAction(accountId, action) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/record-action?action=${action}`
  };
  return axios(config);
}

export function fetchContract(accountId) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/contract`
  };
  return axios(config);
}

export function fetchOrderLimits(accountId) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/order-limits`
  };
  return axios(config);
}

export function fetchAccountSso(accountId) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/account-sso`
  };
  return axios(config);
}

export function fetchLargeOrder(accountId) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/large-order`
  };
  return axios(config);
}